<template>
    <div class="item">
        <div class="info">
            <div class="title">
                <span v-show="address.is_default">預設</span>{{ fullAddress }}
            </div>
            <div class="content">
                {{ content }}
            </div>
        </div>
        <div class="button">
            <img src="@/assets/img/more.png" @click.stop="showMore = true">
        </div>
        <div class="more" v-if="showMore" @click.stop="onCancel">
            <div class="button top" @click.stop="onEdit">
                編輯
            </div>
            <div class="button bottom" @click.stop="onDelete">
                刪除
            </div>
            <div class="button" @click.stop="onCancel">
                取消
            </div>
            <loading loader="spinner"
                     :height="30"
                     :opacity="0.8"
                     :active="isLoading">
                <template slot="before">
                    <div>刪除中...</div>
                </template>
            </loading>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import Loading from 'vue-loading-overlay';
    import Swal from 'sweetalert2'

    export default {
        name: 'AddressItem',
        components: {
            'loading': Loading,
        },
        props: {
            address: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                showMore: false,
                isLoading: false,
            }
        },
        computed: {
            fullAddress() {
                return this.address.city + this.address.district + this.address.road;
            },
            content() {
                let content = [this.address.additional, this.address.alias, this.address.note].filter(val => val).join('/ ');

                return content || '無備註';
            }
        },
        methods: {
            onCancel() {
                this.showMore = false;
            },
            onDelete() {
                this.isLoading = true;

                this.deleteAddress(this.address.id).then(() => {
                    this.isLoading = false;
                    this.showMore = false;
                }).catch(err => {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: err.response.data.message,
                    });
                    this.isLoading = false;
                });
            },
            onEdit() {
                this.$router.push({
                    name: 'address',
                    params: {
                        id: this.address.id
                    }
                });
                this.showMore = false;
            },
            ...mapActions(['deleteAddress'])
        }
    };
</script>

<style lang="scss" scoped>
    .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 5px 15px;
        border-radius: 4px;
        box-shadow: 0 0 3px 0 rgba(51,153,51,0.5);
        padding: 10px;
        text-align: left;

        .info {
            font-size: 14px;
            line-height: 20px;
            width: calc(100% - 30px);

            .title {
                color: #000000;

                span {
                    color: #339933;
                    font-size: 10px;
                    line-height: 14px;
                    margin-right: 5px;
                }
            }

            .content {
                margin-top: 10px;
                color: #9B9B9B;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
            }
        }

        .button {
            img {
                height: 20px;
                width: 20px;
            }
        }
    }

    .more {
        position: absolute;
        bottom: 0;
        top: 0;
        left: 0;
        right: 0;
        background-color: rgba(0,0,0,0.4);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-end;
        z-index: 5;

        .button {
            height: 55px;
            width: 90%;
            margin: 8px 10px 10px 10px;
            border-radius: 14px;
            background-color: #FFFFFF;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #4A4A4A;
            font-size: 20px;
            font-weight: 600;
            letter-spacing: 0.75px;
            line-height: 25px;
            text-align: center;

            &.top {
                background-color: rgba(248,248,248,0.82);
                color: #007AFF;
                font-size: 20px;
                letter-spacing: 0.38px;
                line-height: 25px;
                text-align: center;
                margin: .5px 10px;
                border-radius: 14px 14px 0 0;
            }

            &.bottom {
                background-color: rgba(248,248,248,0.82);
                color: #F44336;
                font-size: 20px;
                letter-spacing: 0.38px;
                line-height: 25px;
                text-align: center;
                margin: .5px 10px;
                border-radius: 0 0 14px 14px;
            }
        }
    }
</style>
